import "./purchaseCover.css";
import NautilusAsset from "./nautilus-asset-page/NautilusAsset";
import useDisclosure from "../../hooks/use-disclosure";
import { useEffect } from "react";

export default function PurchaseCover() {
  const { onHide, onShow, show } = useDisclosure();

  useEffect(() => {
    onShow();
  }, []);
  return (
    <div>
      <NautilusAsset
        onHide={onHide}
        show={show}
        goBack={true}
        redirectURL="https://app.nautilusfinance.io/"
      />
    </div>
  );
}
